import { ReturnMethod } from "./packing-instruction-return-method";

/** Redo's built-in packing instructions, used until a merchant edits them. */
export const DEFAULT_PACKING_INSTRUCTIONS: Readonly<
  Record<ReturnMethod, readonly string[]>
> = {
  [ReturnMethod.CUSTOMER_SHIPS]: [
    "Print this paper.",
    "Cut out the label below.",
    "Package & seal items into poly bag or box.",
    "Tape this label to the package.",
    "Drop off the package at {{drop_off_locations}}",
  ],
  [ReturnMethod.CUSTOMER_IN_STORE]: [
    "Print this paper.",
    "Cut out the label below.",
    "Package & seal items into poly bag or box.",
    "Tape this label to the package.",
    "Drop off the package in store.",
  ],
  [ReturnMethod.PACKAGE_PICKUP]: [
    "Print this paper.",
    "Cut out the label below.",
    "Package & seal items into poly bag or box.",
    "Tape this label to the package.",
    "Have the package ready for pickup on {{pickup_date}}, a carrier will come to pick it up.",
  ],
};

/** Customer-ships default before {{drop_off_locations}} existed. */
export const LEGACY_CARRIER_LOCATION_PACKING_INSTRUCTIONS: readonly string[] = [
  "Print this paper.",
  "Cut out the label below.",
  "Package & seal items into poly bag or box.",
  "Tape this label to the package.",
  "Drop off the package at a {{carrier}} location near you.",
];

/** The customer-ships default before that one. */
export const LEGACY_POST_OFFICE_PACKING_INSTRUCTIONS: readonly string[] = [
  "Print this paper.",
  "Cut out the label below.",
  "Package & seal items into poly bag or box.",
  "Tape this label to the package.",
  "Drop off the package at a {{carrier}} post office near you.",
];

/** Teams that never edited their instructions still store these. */
export const LEGACY_DEFAULT_CUSTOMER_SHIPS_PACKING_INSTRUCTIONS: readonly (readonly string[])[] =
  [
    LEGACY_CARRIER_LOCATION_PACKING_INSTRUCTIONS,
    LEGACY_POST_OFFICE_PACKING_INSTRUCTIONS,
  ];
